
let showDelay = 0;

/**
 * Show random image.
 *
 * @return {Void}
 */
export const showRandomImage = () => {
	const imagesToShow = document.querySelectorAll('.js-images figure:not(.is-visible)');

	if (!imagesToShow.length) {
		return;
	}

	const imageToShow = returnRandomElementFromArray(imagesToShow);

	imageToShow.classList.add('is-visible');

	imageToShow.style.transitionDelay = `${showDelay}ms`;

	showDelay+= 150;

	showRandomImage();
}

/**
 * Return random element from Array.
 *
 * @param  {Array} array
 * @return {type based on array elements}
 */
const returnRandomElementFromArray = (array) => {
	return array[Math.floor(Math.random() * array.length)]
}
